export default "__VITE_ASSET__6bd04fa1__"